export interface User {
  id?: number,
  uid?: string,
  firstname?: string,
  surname?: string,
  email?: string,
  phone?: string,
  image?: string,
  is_staff?: boolean
  is_admin?: boolean,
  operator?: any
}
export interface PaginatedApi<T> {
  count: number,
  next: string,
  prev: string,
  results: T[]
}

export interface Shop {
  id?: number,
  name?: string,
  image?: string,
  icon?: string,
}

export enum PaymentMethods {
  STRIPE_CC = 0,
  CASH = 1,
  BANK_TRANSFER = 2,
  BANK_CHECK = 3,
  BANK_RID = 4,
  CASH_MACHINE = 5,
  UNKNOWN = 6,
  STRIPE_SDD = 7,
  PAYPAL = 8
}

export const paymentMethodsStrings = {
  0: 'Carta di credito',
  1: 'Contanti',
  2: 'Bonifico bancario',
  3: 'Assegno',
  4: 'RID bancario',
  5: 'Bancomat',
  6: 'Sconosciuto',
  7: 'Carta di debito',
  8: 'PayPal'
}

export interface Operator {
  id?: number,
  user?: any,
}

export interface Contact {
  id?: number,
  name?: string,
  surname?: string,
  email?: string,
  phone?: string,
  phone_secondary?: string,
  company?: string,
  city?: string,
  province?: string,
  state?: string,
  notes?: string,
  created_datetime?: string,
  source_operator?: Operator,
  deals?: Deal[]
}

export interface Product {
  id?: number,
  name?: string,
  ac_label?: string
}

export interface Pipeline {
  id?: number,
  title?: string,
}

export interface Conversion {
  id?: number,
  converted?: any,
  deal?: any,
  converting_contact?: Contact,
  seller?: any,
  is_finalized?: boolean,
  contract_signed_date?: string
}

export enum DealStatus {
  OPEN = 1, // Aperto
  WON = 2, // Vinto
  LOST = 3 // Perso
}

export enum DealStatusDescriptions {
  Aperto = 1,
  Vinto = 2,
  Perso = 3
}

export enum ShopOrderStatus {
  PENDING = 0,
  WAITING_CONFIRMATION = 1,
  WAITING_SHOP_SETUP = 2,
  COMPLETED = 3
}

export interface ShopOrder {
  id: number,
  cents_amount: number,
  transaction_id: string,
  status: ShopOrderStatus,
  deal: number,
  shop: number,
  shop_pay_methods: number,
  user: number,
  rate: Rate
}

export interface Deal {
  id?: number,
  contact?: any,
  product?: Product,
  conversion?: any | number,
  status?: number,
  current_pipeline?: number,
  current_stage?: number,
  current_operator?: number,
  is_hot?: boolean,
  shop_orders?: ShopOrder[]
}

export interface Meeting {
  id?: number,
  schedule_datetime?: string,
  deal?: Deal,
  operator?: Operator | number,
  status?: number,
  place?: string,
  notes?: string,
  calendar_link?: string,
  show_date?: boolean,
  scheduled_by?: any
}

export interface Plan {
  id?: number,
  name?: string,
  code?: string,
  rate_number?: number,
  deposit?: number
  link?: string
}

export enum CallStatus {
  PLANNED = 1,
  DONE = 2,
  CANCEL = 3,
  LEAVED = 4
}

export interface Call {
  id: number;
  deal: Deal;
  operator?: Operator;
  description: string;
  schedule_datetime: string;
  status: number;
  priority: number;
  notes?: string;
  completed_datetime?: string;
  has_fixed_time: boolean;
}

export interface Source {
  id: number;
  name: string;
}

export interface SubscriptionPlan {
  id: number
  package?: number
  country?: number
  initial_price?: number
  bonus?: string
  entry_fee?: number
  subscription_fee?: number
  subscription_trial?: number
  subscription_period?: string
  is_active?: boolean
  is_full_price?: boolean
  product_code?: string
  is_experimental?: boolean
  description?: string
}

export interface Rate {
  id: number
  plan?: SubscriptionPlan
  number_total_rate?: number
  queryparam?: string
  payment_fee?: number
  deposit_fee?: number
  rate_trial?: number
  is_active?: boolean
  is_experimental?: boolean
}



// WEBPACK FOOTER //
// ./src/models/models.ts